import { Component, h, Prop, State } from "@stencil/core"
import { CardModel } from "./CardModel"

/**
 * Component which can display the list of cards.
 */
@Component({
  tag: "card-list",
  styleUrl: "CardList.scss",
})
export class CardList {
  /**
   * The text displayes on a expired card.
   */
  @Prop() expiredText: string

  /**
   * The array of cards.
   */
  @Prop() cardList: CardModel[]

  /**
   * Indicator if the screen is loading.
   *
   * @default false
   */
  @Prop() isLoading?: boolean
  /**
   *  Callback called after selecting the card from the list.
   *
   * @param cardListModel Object with data about the card.
   */
  @Prop() setSelectedCard: (cardListModel: CardModel) => void

  @State() currentCard: CardModel

  componentWillLoad() {
    this.initCardList()
  }

  componentWillUpdate() {
    this.initCardList()
  }

  initCardList = () => {
    if (this.cardList && this.cardList.length > 0) {
      const unsortedCardList = this.cardList

      // Sort active cards by date of last used
      const activeCards = unsortedCardList.filter(({ isActive }) => isActive).sort((a, b) => this.sortCards(a, b))

      // Sort inactive and expired cards
      const inactiveCards = unsortedCardList.filter(({ isActive }) => !isActive).sort((a, b) => this.sortCards(a, b))

      this.cardList = [...activeCards, ...inactiveCards]
      if (!this.currentCard) {
        this.setSelectedCardLocal(this.cardList[0])
      }
    }
  }

  setSelectedCardLocal = (cardModel: CardModel) => {
    if (cardModel.isActive) {
      this.currentCard = cardModel
      if (typeof this.setSelectedCard === "function") {
        this.setSelectedCard(cardModel)
      }
    }
  }

  isCardSelected = (cardModel: CardModel): boolean => {
    return this.currentCard && cardModel.srcDigitalCardId === this.currentCard.srcDigitalCardId
  }

  sortCards = (a: CardModel, b: CardModel) => {
    let aDateLastUsed = a.dateOfCardLastUsed
    let bDateLastUsed = b.dateOfCardLastUsed
    if (!aDateLastUsed && !bDateLastUsed) {
      const aDateCreated = a.dateOfCardCreated
      const bDateCreated = b.dateOfCardCreated
      return aDateCreated < bDateCreated ? 1 : aDateCreated > bDateCreated ? -1 : 1
    }
    if (!aDateLastUsed) aDateLastUsed = -1
    if (!bDateLastUsed) bDateLastUsed = -1
    return aDateLastUsed < bDateLastUsed ? 1 : aDateLastUsed > bDateLastUsed ? -1 : 1
  }

  renderCard = (cardModel: CardModel) => {
    return (
      <button
        disabled={cardModel.isActive !== true}
        class={"parent" + (this.isCardSelected(cardModel) ? " selectedBorder" : "")}
        onClick={() => this.setSelectedCardLocal(cardModel)}>
        <input class={"cardListRadioButton"} checked={this.isCardSelected(cardModel)} type="radio"></input>
        <span class={"radioSpan"}></span>
        <img class={"cardImage" + (!cardModel.isActive ? " greyScale" : "")} src={cardModel.artUri}></img>
        <div class="cardTextDiv">
          <div class="cardName">{cardModel.dcfSdk}</div>
          <div class="cardPan">**** {cardModel.lastFourPan}</div>
        </div>
        {!cardModel.isActive && <div class="expiredText">{this.expiredText}</div>}
      </button>
    )
  }

  renderLoadingSpinner = () => (
    <div class="loadingSpinner">
      <loading-spinner diameter="30px" isBlack={true} />
    </div>
  )

  render() {
    if (this.isLoading) return this.renderLoadingSpinner()

    return (
      <div>
        {this.cardList.length > 0 ? (
          this.cardList.map(card => {
            const cardKey = this.cardList.indexOf(card)
            return <div key={cardKey}>{this.renderCard(card)}</div>
          })
        ) : (
          <div></div>
        )}
      </div>
    )
  }
}
